import Grid from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

import ButtonComponent from '#app/Component/ButtonComponent';
import MultipleSelectComponent from '#app/Component/MultipleSelectComponent';
import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import { Channel, ChannelSelects } from '#app/typings/channel';
import { OrderClientState, OrderClientStateSelects } from '#app/typings/orderClient';
import { DisputeType, DisputeTypeSelects } from '#app/typings/orderClientLitige';

export type Filters = {
  types: DisputeType[];
  channels: Channel[];
  orderClientStates: OrderClientState[];
  number: string | null;
  email: string | null;
  name: string | null;
};

type Props = {
  handleSearch: (data: Filters) => void;
  loading: boolean;
};

const Search: React.FC<Props> = ({ handleSearch, loading }) => {
  const classes = useStyles();

  const [formSearch, setFormSearch] = useState<Form>({
    number: {
      name: 'number',
      label: 'Référence',
      textHelper: 'Rechercher par référence.',
      type: 'text',
    },
    email: {
      name: 'email',
      label: 'Email',
      textHelper: 'Rechercher par email.',
      type: 'text',
    },
    name: {
      name: 'name',
      label: 'Client',
      textHelper: 'Rechercher par client.',
      type: 'text',
    },
    channels: {
      name: 'channels',
      label: 'Canal',
      textHelper: 'Rechercher par canaux.',
      type: 'array',
    },
    orderClientStates: {
      name: 'orderClientStates',
      label: 'État de la commande',
      textHelper: 'Rechercher par état.',
      type: 'array',
    },
    types: {
      name: 'types',
      label: 'Type litige',
      textHelper: 'Rechercher par type de litige.',
      type: 'array',
    },
  });

  const handlerFormSearch = initFormHandler(formSearch, setFormSearch);
  useEffect(() => {
    handlerFormSearch.start();
  }, []);

  const getData = (): Omit<Filters, 'page' | 'limit'> => {
    const data = handlerFormSearch.getData();

    return {
      types: data.types,
      channels: data.channels,
      orderClientStates: data.orderClientStates,
      number: data.number,
      email: data.email,
      name: data.name,
    };
  };

  return (
    <ShadowBoxComponent>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="number" handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="email" handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="name" handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent withSelectAll id="channels" options={ChannelSelects} handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent
            withSelectAll
            id="orderClientStates"
            options={OrderClientStateSelects}
            handler={handlerFormSearch}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent withSelectAll id="types" options={DisputeTypeSelects} handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <ButtonComponent
            className={classes.button}
            label="Rechercher"
            onClick={() => handleSearch(getData())}
            disabled={loading}
            loading={loading}
          />
        </Grid>
      </Grid>
    </ShadowBoxComponent>
  );
};

const useStyles = makeStyles({
  button: {
    margin: '6px !important',
  },
});

export default Search;
